/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";
import type { LizardUnitsEnum } from "./LizardUnitsEnum";
import {
  LizardUnitsEnumFromJSON,
  LizardUnitsEnumFromJSONTyped,
  LizardUnitsEnumToJSON,
  LizardUnitsEnumToJSONTyped,
} from "./LizardUnitsEnum";

/**
 * Mixin for validating "offset" and "duration"
 * Assumes simulation to be present on Serializer
 * @export
 * @interface PatchedLizardRasterSourcesSinks
 */
export interface PatchedLizardRasterSourcesSinks {
  /**
   *
   */
  readonly url?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset?: number;
  /**
   * event duration in seconds. -9999 is the 'infinite duration' value (only allowed in conjunction with infinite simulations
   */
  duration?: number | null;
  /**
   *
   */
  referenceUuid?: string;
  /**
   *
   */
  startDatetime?: Date;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  readonly interval?: number;
  /**
   *
   */
  readonly originOffset?: number;
  /**
   *
   */
  readonly storePath?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly user?: string;
  /**
   *
   */
  readonly userId?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
  /**
   *
   */
  multiplier?: number;
  /**
   *
   */
  units?: LizardUnitsEnum;
}

/**
 * Check if a given object implements the PatchedLizardRasterSourcesSinks interface.
 */
export function instanceOfPatchedLizardRasterSourcesSinks(
  value: object
): value is PatchedLizardRasterSourcesSinks {
  return true;
}

export function PatchedLizardRasterSourcesSinksFromJSON(
  json: any
): PatchedLizardRasterSourcesSinks {
  return PatchedLizardRasterSourcesSinksFromJSONTyped(json, false);
}

export function PatchedLizardRasterSourcesSinksFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedLizardRasterSourcesSinks {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    offset: json["offset"] == null ? undefined : json["offset"],
    duration:
      json["duration"] === undefined
        ? undefined
        : json["duration"] === null
        ? null
        : json["duration"],
    referenceUuid: json["reference_uuid"] == null ? undefined : json["reference_uuid"],
    startDatetime:
      json["start_datetime"] == null ? undefined : parseDateTime(json["start_datetime"]),
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    interval: json["interval"] == null ? undefined : json["interval"],
    originOffset: json["origin_offset"] == null ? undefined : json["origin_offset"],
    storePath: json["store_path"] == null ? undefined : json["store_path"],
    id: json["id"] == null ? undefined : json["id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    user: json["user"] == null ? undefined : json["user"],
    userId: json["user_id"] == null ? undefined : json["user_id"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
    multiplier: json["multiplier"] == null ? undefined : json["multiplier"],
    units: json["units"] == null ? undefined : LizardUnitsEnumFromJSON(json["units"]),
  };
}

export function PatchedLizardRasterSourcesSinksToJSON(json: any): PatchedLizardRasterSourcesSinks {
  return PatchedLizardRasterSourcesSinksToJSONTyped(json, false);
}

export function PatchedLizardRasterSourcesSinksToJSONTyped(
  value?: Omit<
    PatchedLizardRasterSourcesSinks,
    | "url"
    | "simulation"
    | "interval"
    | "originOffset"
    | "storePath"
    | "id"
    | "uid"
    | "user"
    | "userId"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    reference_uuid: value["referenceUuid"],
    start_datetime:
      value["startDatetime"] == null
        ? value["startDatetime"]
        : serializeDateTime(value["startDatetime"]),
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
    multiplier: value["multiplier"],
    units: LizardUnitsEnumToJSON(value["units"]),
  };
}
